<template>
  <VProgressCircular indeterminate :size="size" class="iconnections_loader" />
</template>

<script>
export default {
  name: 'IconnectionsLoader',
  props: {
    size: {
      type: Number,
      default: 36,
    },
  },
};
</script>

<style lang="scss">
@import "@foundation";

.iconnections_loader {
  color: map-get($primary, 'purple-500');
}
</style>
